<template>
  <div>
    <!-- Modal para editar.. -->
    <v-dialog v-model="dialogEdit" width="500">
      <v-card>
        <v-toolbar color="primary" class="white--text" flat>
          <v-toolbar-title> Editar Broker externo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="dialogEdit = false" icon color="white">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <!-- ExternalBrokerEdit -->
        <v-card-text>
          <external-broker-edit
            typeComponent="ExternalBroker"
            :getItem="setItem"
            @setValidate="value => (valid = value)"
            @setData="value => (data = value)"
            @setCurrentScreen="value => (currentScreen = value)"
            @closeModal="value => (dialogEdit = value)"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <createBrexComponent />
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="brexList"
      :search="search"
      :footer-props="{ itemsPerPageText: 'Brokers Externos por página' }"
      :sort-by="['created_at']"
    >
      <template v-slot:header.medium="{ header }">
        <span>{{ header.text }}</span>
        <HelpMsgMethodBrexCreation />
      </template>
      <template #item.created_at="{ item }">
        {{ formatDate(item.created_at) }}
      </template>
      <template #item.medium="{ item }">
        {{ getMethodByValue(item.medium).text }}
      </template>
      <template #item.created_by="{ item }">
        {{ contactById(item.created_by)?.name ?? "-" }}
      </template>
      <template #item.leadsCount="{ item }">
        <span v-if="!item.leadsCount">-</span>
        <v-chip v-else small outlined @click="handleShowLeads(item)">
          <v-icon small left>mdi-account-multiple</v-icon>
          <span class="text-button">{{ item.leadsCount }}</span>
        </v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="handleShowLeads(item)">
              <v-list-item-icon>
                <v-icon color="primary">mdi-eye</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Ver Leads</v-list-item-title>
            </v-list-item>
            <v-list-item @click="editItem(item)">
              <v-list-item-icon>
                <v-icon color="primary">mdi-pencil</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Editar</v-list-item-title>
            </v-list-item>
            <v-list-item @click="handleDeleteBrex(item)">
              <v-list-item-icon>
                <v-icon color="error">mdi-delete</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Eliminar</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <ListLeads
      :dialog="dialogLeads"
      :leads="leads"
      :loading="loadingLeads"
      @setDialog="value => (dialogLeads = value)"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { getMethodByValue } from "./components/const";
import { getLeadsByBrex } from "@/api/external-broker-api";

export default {
  components: {
    ExternalBrokerEdit: () =>
      import("@/components/external-broker/ExternalBrokerEdit.vue"),
    createBrexComponent: () => import("./components/createBrexComponent.vue"),
    HelpMsgMethodBrexCreation: () =>
      import("./components/HelpMsgMethodBrexCreation.vue"),
    ListLeads: () =>
      import("@/components/lead/components/simpleListLeadsModal/index.vue")
  },
  name: "ExternalBrokerList",
  created() {
    this.fetchBrexList({ countLeads: true });
  },
  data() {
    return {
      valid: false,
      currentScreen: false,
      data: null,

      dialog: false,
      dialogEdit: false,
      loadingSave: false,

      search: "",
      headers: [
        {
          text: "Nombre",
          align: "start",
          sortable: false,
          value: "name"
        },
        { text: "Teléfono", value: "phone" },
        { text: "Email", value: "email" },
        { text: "Inmobiliaria", value: "real_estate_name" },
        { text: "Creado", value: "created_at" },
        { text: "Metodo de  creacion", value: "medium", sortable: false },
        { text: "Creado por", value: "created_by" },
        { text: "Leads", value: "leadsCount", sortable: true },
        { text: "", value: "actions", sortable: false }
      ],
      setItem: null,
      // Leads
      dialogLeads: false,
      loadingLeads: false,
      leads: []
    };
  },
  computed: {
    ...mapState({
      brexList: state => state.brex.brexList
    }),
    ...mapGetters({
      contactById: "contacts/contactById"
    })
  },
  methods: {
    ...mapActions({
      fetchBrexList: "brex/fetchBrexList",
      deleteBrex: "brex/deleteBrex"
    }),
    /**
     * cuenta las opportunidades registradas o no del broker externo
     * basandose en el campo registered de raw_opportunities_array
     * @param {String} id - Id del Lead
     * @param {boolean} register - Indica si contar los registrado(true) o no registrados(false)
     * @returns {Number} Total
     */
    countOpportunities(id, register) {
      const index = this.brexList.findIndex(brex => brex._id == id);
      const opportunities = this.brexList[index].raw_opportunities_array || [];
      return opportunities.filter(opp => opp.registered == register).length;
    },
    editItem(item) {
      this.dialogEdit = true;
      this.setItem = item;
    },
    formatDate(date) {
      // format 5 abril, 2021
      return new Date(date)
        .toLocaleString("es-MX", {
          day: "numeric",
          month: "long",
          year: "numeric"
        })
        .replace(/de/g, "");
    },
    getMethodByValue,
    async getLeadsByBrex(brexId) {
      const leads = await getLeadsByBrex(brexId);
      return leads;
    },
    async handleShowLeads(item) {
      try {
        this.leads = [];
        this.dialogLeads = true;
        this.loadingLeads = true;
        const response = await this.getLeadsByBrex(item._id);
        this.leads = response.data.Lead.map(lead => {
          return {
            ...lead,
            source: lead.contact?.source?.media.src
          };
        });
      } catch (error) {
        this.$toast.error("Error al obtener los leads");
      } finally {
        this.loadingLeads = false;
      }
    },
    async handleDeleteBrex(item) {
      this.$confirmation(
        "Eliminar Broker Externo",
        "¿Estas seguro que deseas eliminar este broker externo?",
        () => this.deleteBrexConfirm(item)
      );
    },
    async deleteBrexConfirm(item) {
      try {
        await this.deleteBrex(item._id);
        this.$snotify.success(
          "Broker externo eliminado correctamente",
          "Eliminado"
        );
      } catch (error) {
        this.$snotify.error("Error al eliminar el broker externo", "Error");
      }
    }
  }
};
</script>
